/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AlertResponse } from '../models/AlertResponse';
import type { NewAlertResponse } from '../models/NewAlertResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AlertService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get My Alerts
   * Get the list of alerts for the current user.
   * @param slug
   * @returns AlertResponse Successful Response
   * @throws ApiError
   */
  public getMyAlertsV1WorkspacesSlugAlertsGet(slug: string): CancelablePromise<AlertResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/alerts',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get New Alerts
   * Get the list of new alerts for the current user.
   * @param slug
   * @returns NewAlertResponse Successful Response
   * @throws ApiError
   */
  public getNewAlertsV1WorkspacesSlugAlertsNewGet(
    slug: string
  ): CancelablePromise<NewAlertResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/alerts/new',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Read All Alert
   * Read all the alerts for the current user.
   * @param slug
   * @returns any Successful Response
   * @throws ApiError
   */
  public readAllAlertV1WorkspacesSlugAlertsAllPatch(slug: string): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/workspaces/{slug}/alerts/all',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Read Alert
   * Read the alert for the current user.
   * @param uid
   * @param slug
   * @returns any Successful Response
   * @throws ApiError
   */
  public readAlertV1WorkspacesSlugAlertsUidPatch(
    uid: string,
    slug: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/workspaces/{slug}/alerts/{uid}',
      path: {
        uid: uid,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
